/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Pending = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 4">
      <path d="M2 3.5C1.17157288 3.5.5 2.82842712.5 2 .5 1.17157288 1.17157288.5 2 .5 2.82842712.5 3.5 1.17157288 3.5 2 3.5 2.82842712 2.82842712 3.5 2 3.5zM2 1.5C1.72385763 1.5 1.5 1.72385763 1.5 2 1.5 2.27614237 1.72385763 2.5 2 2.5 2.27614237 2.5 2.5 2.27614237 2.5 2 2.5 1.72385763 2.27614237 1.5 2 1.5zM8 3.5C7.17157288 3.5 6.5 2.82842712 6.5 2 6.5 1.17157288 7.17157288.5 8 .5 8.82842712.5 9.5 1.17157288 9.5 2 9.5 2.82842712 8.82842712 3.5 8 3.5zM8 1.5C7.72385763 1.5 7.5 1.72385763 7.5 2 7.5 2.27614237 7.72385763 2.5 8 2.5 8.27614237 2.5 8.5 2.27614237 8.5 2 8.5 1.72385763 8.27614237 1.5 8 1.5zM14 3.5C13.1715729 3.5 12.5 2.82842712 12.5 2 12.5 1.17157288 13.1715729.5 14 .5 14.8284271.5 15.5 1.17157288 15.5 2 15.5 2.82842712 14.8284271 3.5 14 3.5zM14 1.5C13.7238576 1.5 13.5 1.72385763 13.5 2 13.5 2.27614237 13.7238576 2.5 14 2.5 14.2761424 2.5 14.5 2.27614237 14.5 2 14.5 1.72385763 14.2761424 1.5 14 1.5z" />
    </BaseSvgIcon>
  )
}

export default Pending
